//getUserWoAssTask
import _axios from '../../../util/axios/AxiosConfig'

export function getDetail(key){
    return _axios({
        url: `/api/PicMaterial/getDetail?woId=${key}`,
        method: 'get'
    })
}

export function submit(data){
    return _axios({
        url: `/api/PicMaterial/submit`,
        method: 'post',
        data:data
    })
}
